import React from "react";
import { SupLoader } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";

interface LoaderInPageProps {
  className?: string;
  isSmall?: boolean;
}

export default function LoaderInPage({ className, isSmall = false }: LoaderInPageProps) {
  return (
    <div className={twMerge("flex grow overflow-auto xl:overflow-hidden", className)}>
      <SupLoader className="max-h-16 self-center" isSmall={isSmall} />
    </div>
  );
}
